import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import Big from 'big.js';
import { FinancerPendingDetailDTO } from '../../dto/FinancerDistributionDTO';
import { formatMoney, sumMoney } from '../../utils/money';

interface UnsettledNegativesDialogProps {
    /** Filas que restan de órdenes seleccionadas y quedaron afuera. Vacío = cerrado. */
    negatives: FinancerPendingDetailDTO[];
    onAdd: () => void;
    onContinue: () => void;
    onCancel: () => void;
}

/** Modal de decisión (DS §3.8.3): rendir una orden sin su anulación o su crédito le paga de más al profesional. */
export default function UnsettledNegativesDialog({ negatives, onAdd, onContinue, onCancel }: UnsettledNegativesDialogProps) {
    const total: Big = sumMoney(negatives.map(n => n.professionalAmount));

    const footer = (
        <div className="settlement-dialog__footer">
            <Button outlined className="md-ghost" label="Cancelar" onClick={onCancel} />
            <Button outlined className="md-ghost" label="Rendir sin agregarlas" onClick={onContinue} />
            {/* Opción segura: recibe el foco inicial */}
            <Button className="md-primary" label="Agregarlas a la selección" onClick={onAdd} autoFocus />
        </div>
    );

    return (
        <Dialog
            visible={negatives.length > 0}
            onHide={onCancel}
            header="Hay anulaciones o créditos sin seleccionar"
            footer={footer}
            className="settlement-dialog"
            style={{ width: '520px' }}
            modal
        >
            <p style={{ margin: 0, color: 'var(--text)' }}>
                {negatives.length} movimiento(s) que restan {formatMoney(total.abs())} corresponden a órdenes seleccionadas.
                Si no se agregan, se le paga de más al profesional.
            </p>
            <p className="md-help">Solo se revisan las páginas que ya se cargaron.</p>
        </Dialog>
    );
}
